module.exports = __webpack_public_path__ + "media/images/formbeat-logo-light-83e12cbd.svg";